import { list } from './List/List.i18n.en'
import { modalReturn } from './ModalReturn/Modal.i18n.en'
export const attendanceLogs = {
  list,
  modalReturn,
}
